import { render } from "./ClearChatConfirm.vue?vue&type=template&id=e7052774&scoped=true"
import script from "./ClearChatConfirm.vue?vue&type=script&lang=js"
export * from "./ClearChatConfirm.vue?vue&type=script&lang=js"

import "./ClearChatConfirm.vue?vue&type=style&index=0&id=e7052774&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7052774"]])

export default __exports__